import moment, { Moment } from 'moment-timezone';

/**
 * Calculate the number of days from a past date to today.
 */
const getNumberOfDaysToNow = (dateBeforeNowString: string) => {
  const difference =
    new Date(Date.now()).getTime() - new Date(dateBeforeNowString).getTime();

  if (Math.floor(difference) > 0) {
    const numberOfDays = difference / (1000 * 60 * 60 * 24);

    return numberOfDays;
  }

  return 0;
};

const getFormattedSettlementDate = (date?: string) => {
  if (!date) {
    return '';
  }

  const settlementDate = new Date(date);

  return `${settlementDate.getMonth() + 1}月1日 - ${
    settlementDate.getMonth() + 1
  }月${new Date(date).getDate()}日`;
};

const formatMonthDate = (date: string | Moment, format = 'MM月DD日') => {
  return moment(date).tz('Asia/Tokyo').format(format);
};

export const formatFirstDayOfTheMonth = (
  date: string | Moment,
  format = 'MM月DD日'
) => {
  return moment(date).tz('Asia/Tokyo').set('date', 1).format(format);
};

const isDateWithinRange = (date: Date, days: number) => {
  const now = new Date();
  const ninetyDaysAgo = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate() - days
  );

  return date >= ninetyDaysAgo;
};

export {
  isDateWithinRange,
  getNumberOfDaysToNow,
  getFormattedSettlementDate,
  // eslint-disable-next-line comma-dangle
  formatMonthDate,
};
